import React from 'react';

import { Checkbox } from '@lyearn/ui';

import { useAddTaskModalContext } from '../AddTaskModalProvider';

function SelectAll() {
  const { state, methods } = useAddTaskModalContext();
  const { onSelectAllChange } = methods;
  const { isSelectAll, isPartiallySelected } = state;

  return (
    <Checkbox
      checked={isSelectAll}
      data-attr="SELECT"
      indeterminate={isPartiallySelected}
      size="small"
      onChange={onSelectAllChange}
    />
  );
}

export default SelectAll;
